import { makeStyles } from '@fluentui/react-components';

export const useEmptyStateStyles = makeStyles({
  root: {},
});
